import { render } from "./PromotionTabTime.vue?vue&type=template&id=681b35d3"
import script from "./PromotionTabTime.vue?vue&type=script&lang=js"
export * from "./PromotionTabTime.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__